<app-dynamic-modal-form
  size="lg"
  [title]="'Résumé de la demande ' + (request && request.requestType === 'EDIT' ? 'de modification' : 'd\'ajout') + ' d\'utilisateur au portail'"
  [object]="request"
  (onCancel)="onCancel()">
  <ng-template let-object="object">
    @if(object.requestType === 'EDIT') {
      <app-user-request-comparator [asAdmin]="true" [request]="object"
                                   [user]="object.forContact"></app-user-request-comparator>
    } @else {
      <app-user-request-detail [request]="object" [categories]="categories" [crmUrl]="crmUrl"></app-user-request-detail>
    }
  </ng-template>
</app-dynamic-modal-form>
